<template><section>
<h2 id="sample-zu-jian"><a class="header-anchor" href="#sample-zu-jian" aria-hidden="true">¶</a> sample组件</h2>
<h3 id="ji-chu-yong-fa"><a class="header-anchor" href="#ji-chu-yong-fa" aria-hidden="true">¶</a> 基础用法</h3>
<p>基础的按钮用法。</p>
<demo-block class="demo-box">
                      <div class="source" slot="source"><sample :author="author"></sample>
</div>
                      <p>样例代码</p>

                      <div class="highlight" slot="highlight"><pre><code class="hljs language-html"><span class="hljs-tag">&lt;<span class="hljs-name">sample</span> <span class="hljs-attr">:author</span>=<span class="hljs-string">"author"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">sample</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3 id="attributes"><a class="header-anchor" href="#attributes" aria-hidden="true">¶</a> Attributes</h3>
<table class="table"><thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>size</td>
<td>尺寸</td>
<td>string</td>
<td>large</td>
<td>—</td>
</tr>
<tr>
<td>type</td>
<td>类型</td>
<td>string</td>
<td>primary,warning,text</td>
<td>—</td>
</tr>
<tr>
<td>disabled</td>
<td>禁用</td>
<td>boolean</td>
<td>true, false</td>
<td>false</td>
</tr>
<tr>
<td>icon</td>
<td>图标，已有的图标库中的图标名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>to</td>
<td>路由跳转路径</td>
<td>Object</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
</section></template>

<script>
export default {
  data() {
    return {
      author: 'test'
    };
  }
};
</script>


// WEBPACK FOOTER //
// sample-1.vue?ce011e08